import Vue from 'vue'
import urls from '../services.url.js'

export default {
  getSkills (skillString) {
    let target = urls.SKILL_LIST_URL + skillString + '/'
    return Vue.http.get(target)
  },
  getSkillForPlayerByCat (playerId) {
    let target = urls.SKILL_LIST_FOR_PLAYER_URL + playerId + '/'
    return Vue.http.get(target)
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/skills.api.js